export class MockMatDialogRef {
  id: string;
  close = jasmine.createSpy('close');
}
